import React from 'react';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import LowPriorityIcon from '@material-ui/icons/LowPriority';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import GetAppIcon from '@material-ui/icons/GetApp';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CreateIcon from '@material-ui/icons/Create';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import DomainIcon from '@material-ui/icons/Domain';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ApartmentIcon from '@material-ui/icons/Apartment';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import BuildIcon from '@material-ui/icons/Build';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import { NotificationImportant } from '@material-ui/icons';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import StorageIcon from '@material-ui/icons/Storage';
import TuneIcon from '@material-ui/icons/Tune';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import BlurLinearIcon from '@material-ui/icons/BlurLinear';
import WorkIcon from '@material-ui/icons/Work';
import BallotIcon from '@material-ui/icons/Ballot';
import MapIcon from '@material-ui/icons/Map';
import ProgressIcon from './ProgressIcon';
import GraphicEqIcon from '@material-ui/icons/GraphicEq';
import ExtensionIcon from '@material-ui/icons/Extension';
import DescriptionIcon from '@material-ui/icons/Description';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import EventNoteIcon from '@material-ui/icons/EventNote';
import CodeIcon from '@material-ui/icons/Code';

const MyIcons = (props) => {
    const { icon, ...rest } = props;
    return (
        <>
            {icon === 'photoCamera' && <PhotoCamera {...rest} />}
            {icon === 'lowPriorityIcon' && <LowPriorityIcon {...rest} />}
            {icon === 'equalizerIcon' && <EqualizerIcon {...rest} />}
            {icon === 'filterNoneIcon' && <FilterNoneIcon {...rest} />}
            {icon === 'getAppIcon' && <GetAppIcon {...rest} />}
            {icon === 'personAddIcon' && <PersonAddIcon {...rest} />}
            {icon === 'deleteOutlineIcon' && <DeleteOutlineIcon {...rest} />}
            {icon === 'addCircleOutlineIcon' && <AddCircleOutlineIcon {...rest} />}
            {icon === 'createIcon' && <CreateIcon {...rest} />}
            {icon === 'peopleAltIcon' && <PeopleAltIcon {...rest} />}
            {icon === 'domainIcon' && <DomainIcon {...rest} />}
            {icon === 'companyIcon' && <DomainIcon {...rest} />}
            {icon === 'accountTreeIcon' && <AccountTreeIcon {...rest} />}
            {icon === 'apartmentIcon' && <ApartmentIcon {...rest} />}
            {icon === 'assessmentIcon' && <AssessmentIcon {...rest} />}
            {icon === 'playlistAddCheckIcon' && <PlaylistAddCheckIcon {...rest} />}
            {icon === 'buildIcon' && <BuildIcon {...rest} />}
            {icon === 'developerBoardIcon' && <DeveloperBoardIcon {...rest} />}
            {icon === 'notificationImportant' && <NotificationImportant {...rest} />}
            {icon === 'settingsIcon' && <SettingsIcon {...rest} />}
            {icon === 'logOutIcon' && <ExitToAppIcon {...rest} />}
            {icon === 'passwordIcon' && <VpnKeyIcon {...rest} />}
            {icon === 'apiKeyIcon' && <CodeIcon {...rest} />}
            {icon === 'dataUsageIcon' && <StorageIcon {...rest} />}
            {icon === 'settingIcon' && <TuneIcon {...rest} />}
            {icon === 'locationIcon' && <MyLocationIcon {...rest} />}
            {icon === 'unitsIcon' && <BlurLinearIcon {...rest} />}
            {icon === 'jobsIcon' && <WorkIcon {...rest} />}
            {icon === 'componentsIcon' && <BallotIcon {...rest} />}
            {icon === 'mapIcon' && <MapIcon {...rest} />}
            {icon === 'progressIcon' && <ProgressIcon {...rest} />}
            {icon === 'graphicEqIcon' && <GraphicEqIcon {...rest} />}
            {icon === 'extensionIcon' && <ExtensionIcon {...rest} />}
            {icon === 'descriptionIcon' && <DescriptionIcon {...rest} />}
            {icon === 'menuBookIcon' && <MenuBookIcon {...rest} />}
            {icon === 'creditCardIcon' && <CreditCardIcon {...rest} />}
            {icon === 'jobPlannerIcon' && <EventNoteIcon {...rest} />}
        </>
    );
};
export default MyIcons;